import {formatTons} from '@hconnect/uikit'
import {Box} from '@mui/material'
import {DatetimeValueChartYLabels, LinearScaleFn} from '@widgets/common-d3-chart'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'

interface OptimizerStockLevelsChartLabelsProps {
  storageCapacity: number
  yScale: LinearScaleFn
}

export const OptimizerStockLevelsChartLabels: React.FC<OptimizerStockLevelsChartLabelsProps> = ({
  storageCapacity,
  yScale
}) => {
  const {
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)

  const chartYSteps = [0, storageCapacity]

  return (
    <Box
      sx={{
        width: ({spacing}) => spacing(6),
        pr: 0.5
      }}
    >
      <DatetimeValueChartYLabels
        ySteps={chartYSteps}
        yScale={yScale}
        yStepsFormatter={(step, index) =>
          formatTons(Number(step), language) + (index === chartYSteps.length - 1 ? ' (max)' : '')
        }
      />
    </Box>
  )
}
